import React, { FunctionComponent, useEffect, useState } from 'react'
import { T } from '@transifex/react'
import { reactular } from '@vendhq/reactular'
import { useWebRegisterManager } from '../../ng-compat/hooks'

export const LoadingSkeleton: FunctionComponent = () => {
  const webRegisterManager = useWebRegisterManager()

  const [translationsAvailable, setTranslationsAvailable] = useState<boolean>(
    webRegisterManager.getTranslationsAvailable()
  )

  useEffect(() => {
    const updateTranslationsAvailable = () => {
      setTranslationsAvailable(webRegisterManager.getTranslationsAvailable())
    }

    webRegisterManager.on('translationsAvailable', updateTranslationsAvailable)

    return () => {
      webRegisterManager.off(
        'translationsAvailable',
        updateTranslationsAvailable
      )
    }
  }, [webRegisterManager])

  return (
    <div className="loading-skeleton">
      <div
        className="loading-skeleton-topbar"
        data-testid="loading-skeleton-topbar"
      >
        <div className="loading-skeleton-topnav-header">
          <div className="vd-logo-container">
            <img
              alt="Lightspeed Logo"
              src="//vendfrontendassets.freetls.fastly.net/images/logos/lightspeed-logo-all-white-v2.svg"
              className="vd-logo"
              width="120px"
            />
          </div>
        </div>
      </div>

      <div className="loading-skeleton-content vd-pa5">
        <div className="vd-loader loading-skeleton-loader"></div>
        {translationsAvailable ? (
          <>
            <div className="vd-text-heading vd-mb3">
              <T _str="Getting ready to sell…" />
            </div>
            <p className="vd-p">
              <T _str="If you're loading for the first time, this might take a while." />
            </p>
          </>
        ) : null}
      </div>
    </div>
  )
}

export const ReactLoadingSkeleton = reactular(
  LoadingSkeleton,
  [],
  'reactWrapper'
)
